import { Box, Group, Paper, Stack, Text, type PaperProps } from '@mantine/core';
import type { ReactNode } from 'react';
import type { WidgetProps } from './types';

export interface WidgetFrameProps extends WidgetProps, Omit<PaperProps, 'title'> {
  children: ReactNode;
  actions?: ReactNode;
}

/** Необязательная оболочка виджета; оформление Paper можно переопределить пропами. */
export function WidgetFrame({ title, actions, children, ...props }: WidgetFrameProps) {
  return (
    <Paper p='md' radius='md' withBorder {...props}>
      <Stack gap='sm'>
        {(title != null || actions != null) && (
          <Group justify='space-between' align='flex-start' wrap='nowrap'>
            {title != null && (
              <Text component='div' size='sm' fw={600} style={{ flex: 1, minWidth: 0 }}>
                {title}
              </Text>
            )}
            {actions != null && <Box ml='auto'>{actions}</Box>}
          </Group>
        )}
        {children}
      </Stack>
    </Paper>
  );
}
